import React, { useState, useEffect } from 'react'
import { useParams } from 'react-router-dom'
import { useAuth } from '../AuthContext'
import { glass } from '../glassStyles'

export default function SiteOperatorManagement() {
  const { siteId } = useParams()
  const { authHeaders } = useAuth()
  const [operators, setOperators] = useState([])
  const [templates, setTemplates] = useState([])
  const [showForm, setShowForm] = useState(false)
  const [form, setForm] = useState({ login_id: '', password: '', name: '', email: '', permission_template_id: '' })
  const [saving, setSaving] = useState(false)
  const [editId, setEditId] = useState(null)

  const load = () => {
    fetch(`/api/sites/${siteId}/operators`, { headers: authHeaders() })
      .then(r => r.json()).then(setOperators).catch(() => {})
    fetch(`/api/sites/${siteId}/permission-templates`, { headers: authHeaders() })
      .then(r => r.json()).then(setTemplates).catch(() => {})
  }
  useEffect(load, [siteId])

  const handleSubmit = async () => {
    if (!form.login_id || !form.name || (!editId && !form.password)) return
    setSaving(true)
    try {
      if (editId) {
        await fetch(`/api/sites/${siteId}/operators/${editId}`, {
          method: 'PUT', headers: { ...authHeaders(), 'Content-Type': 'application/json' },
          body: JSON.stringify({ name: form.name, email: form.email, permission_template_id: form.permission_template_id || null }),
        })
      } else {
        await fetch(`/api/sites/${siteId}/operators`, {
          method: 'POST', headers: { ...authHeaders(), 'Content-Type': 'application/json' },
          body: JSON.stringify(form),
        })
      }
      setShowForm(false)
      setEditId(null)
      setForm({ login_id: '', password: '', name: '', email: '', permission_template_id: '' })
      load()
    } catch {}
    finally { setSaving(false) }
  }

  const handleDelete = async (id, name) => {
    if (!confirm(`${name} を削除しますか？`)) return
    await fetch(`/api/sites/${siteId}/operators/${id}`, { method: 'DELETE', headers: authHeaders() })
    load()
  }

  const startEdit = (op) => {
    setForm({ login_id: op.login_id, password: '', name: op.name, email: op.email || '', permission_template_id: op.permission_template_id || '' })
    setEditId(op.id)
    setShowForm(true)
  }

  const inputStyle = { width: '100%', padding: '8px 12px', borderRadius: 8, border: '1px solid rgba(255,255,255,0.12)', background: 'rgba(255,255,255,0.06)', color: '#fff', fontSize: 13, boxSizing: 'border-box' }

  return (
    <div>
      <h1 style={{ fontSize: 24, fontWeight: 700, color: 'rgba(255,255,255,0.9)', margin: '0 0 8px' }}>オペレータ管理</h1>
      <p style={{ fontSize: 13, color: 'rgba(255,255,255,0.5)', margin: '0 0 20px' }}>
        サイト内のオペレータの登録・編集・権限グループの割り当てを行います
      </p>

      <div style={{ marginBottom: 20 }}>
        <button onClick={() => { setShowForm(!showForm); setEditId(null); setForm({ login_id: '', password: '', name: '', email: '', permission_template_id: '' }) }}
          style={{ ...glass.btn, ...glass.btnPrimary, padding: '10px 24px', fontSize: 13 }}>
          {showForm ? 'キャンセル' : '+ 新規オペレータ登録'}
        </button>
      </div>

      {showForm && (
        <div style={{ ...glass.cardDark, padding: 24, marginBottom: 20 }}>
          <h3 style={{ fontSize: 15, fontWeight: 700, color: 'rgba(255,255,255,0.9)', margin: '0 0 16px' }}>
            {editId ? 'オペレータ編集' : '新規オペレータ登録'}
          </h3>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 14 }}>
            <div>
              <label style={{ fontSize: 12, color: 'rgba(255,255,255,0.5)', display: 'block', marginBottom: 4 }}>ログインID *</label>
              <input value={form.login_id} onChange={e => setForm({ ...form, login_id: e.target.value })} disabled={!!editId} style={inputStyle} />
            </div>
            <div>
              <label style={{ fontSize: 12, color: 'rgba(255,255,255,0.5)', display: 'block', marginBottom: 4 }}>
                パスワード {editId ? '（変更しない場合は空欄）' : '*'}
              </label>
              <input type="password" value={form.password} onChange={e => setForm({ ...form, password: e.target.value })} style={inputStyle} />
            </div>
            <div>
              <label style={{ fontSize: 12, color: 'rgba(255,255,255,0.5)', display: 'block', marginBottom: 4 }}>名前 *</label>
              <input value={form.name} onChange={e => setForm({ ...form, name: e.target.value })} style={inputStyle} />
            </div>
            <div>
              <label style={{ fontSize: 12, color: 'rgba(255,255,255,0.5)', display: 'block', marginBottom: 4 }}>メールアドレス</label>
              <input value={form.email} onChange={e => setForm({ ...form, email: e.target.value })} style={inputStyle} />
            </div>
            <div>
              <label style={{ fontSize: 12, color: 'rgba(255,255,255,0.5)', display: 'block', marginBottom: 4 }}>権限グループ</label>
              <select value={form.permission_template_id} onChange={e => setForm({ ...form, permission_template_id: e.target.value ? parseInt(e.target.value) : '' })} style={inputStyle}>
                <option value="">-- 選択 --</option>
                {templates.map(t => <option key={t.id} value={t.id}>{t.name}{t.is_system ? '（システム）' : ''}</option>)}
              </select>
            </div>
          </div>
          <div style={{ marginTop: 16 }}>
            <button onClick={handleSubmit} disabled={saving}
              style={{ ...glass.btn, ...glass.btnPrimary, padding: '10px 28px', fontSize: 13, opacity: saving ? 0.6 : 1 }}>
              {saving ? '保存中...' : editId ? '更新する' : '登録する'}
            </button>
          </div>
        </div>
      )}

      <div style={{ ...glass.cardDark, padding: 24 }}>
        <h3 style={{ fontSize: 15, fontWeight: 700, color: 'rgba(255,255,255,0.9)', margin: '0 0 16px' }}>オペレータ一覧</h3>
        <div style={{ overflowX: 'auto' }}>
          <table style={{ width: '100%', borderCollapse: 'collapse' }}>
            <thead>
              <tr>
                {['名前', 'ログインID', 'メール', 'ロール', '権限グループ', '登録日', '操作'].map(h => (
                  <th key={h} style={{ textAlign: 'left', padding: '8px 10px', fontSize: 11, fontWeight: 700, color: 'rgba(255,255,255,0.5)', borderBottom: '1px solid rgba(255,255,255,0.08)' }}>{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {operators.map(op => (
                <tr key={op.id} style={{ borderBottom: '1px solid rgba(255,255,255,0.05)' }}>
                  <td style={{ padding: '10px', fontSize: 13, fontWeight: 600, color: 'rgba(255,255,255,0.85)' }}>{op.name}</td>
                  <td style={{ padding: '10px', fontSize: 12, color: 'rgba(255,255,255,0.6)' }}>{op.login_id}</td>
                  <td style={{ padding: '10px', fontSize: 12, color: 'rgba(255,255,255,0.5)' }}>{op.email || '-'}</td>
                  <td style={{ padding: '10px' }}>
                    <span style={{ padding: '2px 10px', borderRadius: 8, fontSize: 10, fontWeight: 700,
                      background: op.role === 'site_owner' ? 'rgba(245,158,11,0.15)' : 'rgba(99,102,241,0.15)',
                      color: op.role === 'site_owner' ? '#fbbf24' : '#a5b4fc' }}>
                      {op.role === 'site_owner' ? 'サイトオーナー' : 'メンバー'}
                    </span>
                  </td>
                  <td style={{ padding: '10px', fontSize: 12, color: 'rgba(255,255,255,0.6)' }}>
                    {op.role === 'site_owner' ? '全権限' : (op.permission_template_name || '未設定')}
                  </td>
                  <td style={{ padding: '10px', fontSize: 11, color: 'rgba(255,255,255,0.4)' }}>
                    {op.created_at ? new Date(op.created_at).toLocaleDateString('ja-JP') : ''}
                  </td>
                  <td style={{ padding: '10px' }}>
                    {op.role !== 'site_owner' && (
                      <div style={{ display: 'flex', gap: 6 }}>
                        <button onClick={() => startEdit(op)} style={{ padding: '4px 12px', borderRadius: 6, border: '1px solid rgba(99,102,241,0.3)', background: 'rgba(99,102,241,0.1)', color: '#a5b4fc', fontSize: 11, cursor: 'pointer' }}>編集</button>
                        <button onClick={() => handleDelete(op.id, op.name)} style={{ padding: '4px 12px', borderRadius: 6, border: '1px solid rgba(239,68,68,0.3)', background: 'rgba(239,68,68,0.1)', color: '#fca5a5', fontSize: 11, cursor: 'pointer' }}>削除</button>
                      </div>
                    )}
                  </td>
                </tr>
              ))}
              {operators.length === 0 && (
                <tr><td colSpan={7} style={{ padding: '24px 10px', textAlign: 'center', color: 'rgba(255,255,255,0.3)', fontSize: 13 }}>オペレータが登録されていません</td></tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  )
}
